import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../../shared/modal-cadastro/modal-cadastro.component';
import { FormGroup, FormControl } from '@angular/forms';
import { NotasFiscaisService } from '../../../../services/notas-fiscais.service';
import { MessageService } from '../../../../services/message.service';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';
import { getErrorMessage, saveBlobToFile } from '../../../../general/utils';

@Component({
  selector: 'app-relatorio-gerencial',
  templateUrl: './relatorio-gerencial.component.html',
  styleUrls: ['./relatorio-gerencial.component.css']
})
export class RelatorioGerencialComponent extends ModalCadastroComponent implements OnInit {

  constructor(
    private notasFiscaisService: NotasFiscaisService,
    private messageService: MessageService
  ) { super(); }

  @ViewChild('modalRelatorio', { static: true }) modalRelatorio;
  form: FormGroup;

  ngOnInit() {
    this.form = new FormGroup({
      periodo1: new FormControl(moment().startOf('month').toDate()),
      periodo2: new FormControl(moment().endOf('month').startOf('day').toDate()),
      formato: new FormControl('pdf'),
      tipoDeRelatorio: new FormControl('saida'),
      clienteID: new FormControl(null),
    });
  }

  show() {
    this.modalRelatorio.show();
  }

  get fileName() {
    let name = 'Relatório Gerencial';
    const p1 = moment(this.form.get('periodo1').value).format('DD-MM-YYYY');
    const p2 = moment(this.form.get('periodo2').value).format('DD-MM-YYYY');
    if (p1 && p2) {
      name += ` ${p1} ${p2}`;
    }
    return name;
  }

  submitForm() {
    this.loading['consulta'] = true;

    this.messageService.addToast({
      title: 'Emitindo Relatório',
      msg: 'Gerencial',
      showClose: false, timeout: 0, theme: 'bootstrap', closeOther: false
    });

    this.notasFiscaisService.imprimirRelatorioGerencial(this.form.value)
      .pipe(finalize(() => {
        this.loading['consulta'] = false;
        this.messageService.clearAll();
      }))
      .subscribe({
        next: (res) => {
          this.messageService.success('Relatorio gerado com sucesso', 5000);
          saveBlobToFile(res, this.fileName);
        },
        error: (error) => {
          this.messageService.error('Ocorreu um erro ao emitir o relatório. ' + getErrorMessage(error), 5000, 'Atenção!')
        },
      });
  }

  onClose() {
    this.closed.emit();
  }
}
